import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

// Define the base API
export const resultApi = createApi({
    reducerPath: 'resultApi',
    baseQuery: baseQuery(),
    tagTypes: ['Result'],
    endpoints: (builder) => ({
        // list results API
        listResults: builder.query({
            query: (body) => ({
                url: `/result`,
                method: 'POST',
                body: body,
            }),
            providesTags: ['Result'],
        }),
        // fetch an result by id
        fetchResult: builder.query({
            query: (id) => ({
                url: `/result/${id}`,
            }),
        }),
    }),
});

export const {
    useListResultsQuery,
    useFetchResultQuery,
} = resultApi;

export default resultApi;
